var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-lists"},[_c('fm-table-new',{key:_vm.loadKey,attrs:{"full":true,"auto-height":"","border":"row","stripe":false,"columns":_vm.columns,"data-list":_vm.dataList},on:{"row-dbclick":_vm.rowDbClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }